import script from "./dt-confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./dt-confirm.vue?vue&type=script&setup=true&lang=js"

import "./dt-confirm.vue?vue&type=style&index=0&id=5a72f44a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a72f44a"]])

export default __exports__